import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import PageTracker from "@/components/PageTracker";
import BrevoWidget from "@/components/BrevoWidget";
import CookieConsent from "@/components/CookieConsent";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Index from "./pages/Index";
import MentionsLegales from "./pages/MentionsLegales";
import CGU from "./pages/CGU";
import Confidentialite from "./pages/Confidentialite";
import UseCases from "./pages/UseCases";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import Fonctionnalites from "./pages/Fonctionnalites";
import Tarifs from "./pages/Tarifs";
import NotFound from "./pages/NotFound";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdsLanding from "@/pages/AdsLanding";
import StandardTelephoniqueImmobilier from "@/pages/StandardTelephoniqueImmobilier";
import PermanenceTelephoniqueImmobilier from "@/pages/PermanenceTelephoniqueImmobilier";
import AccueilTelephoniqueImmobilier from "@/pages/AccueilTelephoniqueImmobilier";
import TelephonieAgenceImmobiliere from "@/pages/TelephonieAgenceImmobiliere";
import AppelsManquesAgenceImmobiliere from "@/pages/AppelsManquesAgenceImmobiliere";
import QualificationAppelsImmobilier from "@/pages/QualificationAppelsImmobilier";
import AgentVocalIaImmobilier from "@/pages/AgentVocalIaImmobilier";

const queryClient = new QueryClient();

const RootLayout = () => (
  <LanguageProvider>
    <ScrollToTop />
    <PageTracker />
    <BrevoWidget />
    <CookieConsent />
    <Outlet />
  </LanguageProvider>
);

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Index /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog/:slug", element: <BlogPost /> },
      { path: "/ads", element: <Navigate to="/landing-immovox-offre-2026" replace /> },
      { path: "/landing-immovox-offre-2026", element: <AdsLanding /> },
      { path: "/mentions-legales", element: <MentionsLegales /> },
      { path: "/cgu", element: <CGU /> },
      { path: "/confidentialite", element: <Confidentialite /> },
      { path: "/cas-dusage", element: <UseCases /> },
      { path: "/a-propos", element: <APropos /> },
      { path: "/contact", element: <Contact /> },
      { path: "/fonctionnalites", element: <Fonctionnalites /> },
      { path: "/tarifs", element: <Tarifs /> },
      { path: "/standard-telephonique-immobilier", element: <StandardTelephoniqueImmobilier /> },
      { path: "/permanence-telephonique-immobilier", element: <PermanenceTelephoniqueImmobilier /> },
      { path: "/accueil-telephonique-immobilier", element: <AccueilTelephoniqueImmobilier /> },
      { path: "/telephonie-agence-immobiliere", element: <TelephonieAgenceImmobiliere /> },
      { path: "/standard-automatique-immobilier", element: <Navigate to="/standard-telephonique-immobilier" replace /> },
      { path: "/standard-virtuel-agence-immobiliere", element: <Navigate to="/standard-telephonique-immobilier" replace /> },
      { path: "/secretariat-telephonique-immobilier", element: <Navigate to="/permanence-telephonique-immobilier" replace /> },
      { path: "/repondeur-intelligent-agence-immobiliere", element: <Navigate to="/standard-telephonique-immobilier" replace /> },
      { path: "/gestion-appels-agence-immobiliere", element: <Navigate to="/accueil-telephonique-immobilier" replace /> },
      { path: "/appels-manques-agence-immobiliere", element: <AppelsManquesAgenceImmobiliere /> },
      { path: "/qualification-appels-immobilier", element: <QualificationAppelsImmobilier /> },
      { path: "/agent-vocal-ia-immobilier", element: <AgentVocalIaImmobilier /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <RouterProvider router={router} />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
